import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Modals from "../components/modals";
import Footer from "../components/footer";

import List from "../components/search/list";

export default class Search extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: 'Productos',
            text: [],
            products:[],
            brandsT:[],
            categoriesT:[],
            linesT:[],
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
            formRegister:{
                name:'',
                lastname:'',
                identy:'',
                mail:'',
                password:'',
                phone:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            countries:[],
            states:[],
            cities:[],
            formLogin:{
                user:'',
                password:'',
                token:'',
            },
        }

        this.formRegisterSubmit = this.formRegisterSubmit.bind(this)
        this.handleChangeFormRegister = this.handleChangeFormRegister.bind(this)
        this._recaptchaRefRegister = React.createRef();
        this.onChangeCountry = this.onChangeCountry.bind(this)
        this.onChangeState = this.onChangeState.bind(this)
        this.onChangeCity = this.onChangeCity.bind(this)

        this.forget = this.forget.bind(this);
        this.formLoginSubmit = this.formLoginSubmit.bind(this)
        this.handleChangeFormLogin = this.handleChangeFormLogin.bind(this)
        this._recaptchaRefLogin = React.createRef();

        this.pagePrev = this.pagePrev.bind(this)
        this.pageNext = this.pageNext.bind(this)
    }

    //register_form started
    handleChangeFormRegister(e){
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                [e.target.name]:e.target.value
            }
        })
    }
    
    onChangeCountry(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                country_id:e.target.value,
            }
        });
    }

    onChangeState(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                state_id:e.target.value,
            }
        });
    }

    onChangeCity(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                city_id:e.target.value,
            }
        });
    }

    formRegisterSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formRegister.name == '' ||
            this.state.formRegister.lastname == '' ||
            //this.state.formRegister.identy == '' ||
            this.state.formRegister.mail == '' ||
            this.state.formRegister.password == '' ||
            this.state.formRegister.phone == '' ||
            this.state.formRegister.address == ''||
            this.state.formRegister.town == '' ||
            this.state.formRegister.city_id == '' ||
            this.state.formRegister.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        const tokenRegister = await this._recaptchaRefRegister.current.executeAsync();
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                token: tokenRegister
            }
        });

        if(!tokenRegister){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }
        try{
            let configRegister = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formRegister)
            }
            let resRegister = await fetch(`${https}api/register`,configRegister)
            let dataRegister = await resRegister.json()
            if(dataRegister == 1){
                this.setState({
                    formRegister:{
                        name:'',
                        lastname:'',
                        identy:'',
                        mail:'',
                        password:'',
                        phone:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formRegister").reset();
                $("#formRegister")[0].reset();
                swal({
                    text: "Gracias por registrarse, pronto nos contactaremos con usted",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataRegister == 2) {
                swal({
                    text: "Este usuario ya se encuentra registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //register_form finished

    forget = async (e) =>{
        e.preventDefault()
        if(
            this.state.formLogin.user == ''
        ){
            swal({
                text: "Debes digitar el correo electronico",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configForget = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resForget = await fetch(`${https}api/forget`,configForget)
            let dataForget = await resForget.json()
            if(dataForget == 1){
                swal({
                    text: "Se ha enviado un correo a "+this.state.formLogin.user,
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 2) {
                swal({
                    text: "Error de recaptcha",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 3) {
                swal({
                    text: "Usuario no registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 4){
                swal({
                    text: "Su usuario no tiene los permisos necesarios para acceder",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                //console.log(dataForget);
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    handleChangeFormLogin(e){
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                [e.target.name]:e.target.value
            }
        })
    }
    
    formLoginSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formLogin.user == '' ||
            this.state.formLogin.password == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        const token = await this._recaptchaRefLogin.current.executeAsync();
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                token: token
            }
        });
        if(!token){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }
        try{
            let configLogin = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resLogin = await fetch(`${https}api/login`,configLogin)
            let dataLogin = await resLogin.json()
            if(dataLogin == 1){
                this.setState({
                    formLogin:{
                        user:'',
                        password:'',
                        token:'',
                    }
                })
                //document.getElementById("formLogin").reset();
                location.reload();
            }else if(dataLogin == 2) {
                swal({
                    text: "Error de recaptcha",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataLogin == 3) {
                swal({
                    text: "Usuario o contraseña incorrecta",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataLogin == 4){
                swal({
                    text: "Su usuario no tiene los permisos necesarios para acceder",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    //filters shop

    pagePrev(id){
        id = $('.pagePrev').attr('id')
        if(id > 0){
            $('.pages').hide();
            $('.page_'+id).show();
            $('.pagePrev').attr('id',parseInt(id)-1)
            $('.pageNext').attr('id',parseInt(id)+1)
            $('html, body').animate({
                scrollTop: $('.listProducts').offset().top - 100
            }, 100);
        }else{
            swal({
                text: "No hay pagina anterior para mostrar",
                icon: imageURL,
                button: "OK!",
            });
        }
    }

    pageNext(id){
        id = $('.pageNext').attr('id')
        if( id > 1 ){
            if( $(".page_"+id).length == 0 ){
                swal({
                    text: "No hay pagina siguiente para mostrar",
                    icon: imageURL,
                    button: "OK!",
                });
                return false;
            }
            var id_next = parseInt(id) + 1;
            $('.pages').hide();
            $('.page_'+id).show();
            $('.pagePrev').attr('id',parseInt(id)-1)
            if($(".page_"+id_next).length >= 0){
                $('.pageNext').attr('id',id_next)
            }
            $('html, body').animate({
                scrollTop: $('.listProducts').offset().top - 100
            }, 100);
        }else{
            swal({
                text: "No hay pagina siguiente para mostrar",
                icon: imageURL,
                button: "OK!",
            });
        }
    }

    

    async componentDidMount(){
        //text
        try{
            let res = await fetch(https+'api/text')
            let data = await res.json()
            this.setState({
                text:data[3],
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //products
        try{
            fetch(https+'api/productsGet/'+name_search)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        products:data
                    })
                    $('.not_products').css('display','block');
                    $('.loading').css('display','none');
                })
        }catch (error) {
            this.setState({
                error
            })
        }
        //lines_Totally
        try{
            let res = await fetch(https+'api/lines')
            let data = await res.json()
            this.setState({
                linesT:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands_Totally
        try{
            let res = await fetch(https+'api/brands')
            let data = await res.json()
            this.setState({
                brandsT:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //category_totally
        try{
            let res = await fetch(https+'api/categories')
            let data = await res.json()
            this.setState({
                categoriesT:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }



        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //city
        try{
            let res = await fetch(https+'api/cities')
            let data = await res.json()
            this.setState({
                cities:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }

    
    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <List
                    text={this.state.text}
                    products={this.state.products}
                    prev={this.pagePrev}
                    next={this.pageNext}
                    linesT={this.state.linesT}
                    categoriesT={this.state.categoriesT}
                    brandsT={this.state.brandsT}
                />
                <Float
                    info={this.state.info}
                />
                <Modals
                    form={this.state.formRegister}
                    onChange={this.handleChangeFormRegister}
                    onSubmit={this.formRegisterSubmit}
                    recaptchaRefRegister={this._recaptchaRefRegister}
                    onChangeCountry={this.onChangeCountry}
                    onChangeState={this.onChangeState}
                    onChangeCity={this.onChangeCity}
                    cities={this.state.cities}
                    forget={this.forget}
                    formlogin={this.state.formLogin}
                    onChangeLogin={this.handleChangeFormLogin}
                    recaptchaRefLogin={this._recaptchaRefLogin}
                    onSubmitLogin={this.formLoginSubmit}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_search')) {
    ReactDOM.render(<Search />, document.getElementById('content_search'))
}
